import { render, staticRenderFns } from "./MultiSelectField.vue?vue&type=template&id=2dab83b5&scoped=true"
import script from "./MultiSelectField.vue?vue&type=script&lang=js"
export * from "./MultiSelectField.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectField.vue?vue&type=style&index=0&id=2dab83b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab83b5",
  null
  
)

export default component.exports